import React from 'react';

/* Common */
import { Button } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionComponentHeader({ component }) {
    const { name, id, metadata } = component;
    const { title, intro, tooltip } = metadata;

    return (
        <>
            <div className={`col col--flow-component-${name}`}>
                {title && (
                    <p className={`flow__header-title flow__header-title--${id}`}>
                        {title}
                    </p>
                )}
                {intro && (
                    <p className={`flow__header-intro flow__header-intro--${id}`}>
                        {intro}
                    </p>
                )}
            </div>
            {tooltip && (
                <div className={`col col--flow-component-${name}`}>
                    <Button
                        className={'btn--flow-more-info'}
                        theme={'white'}
                        href={tooltip}
                        target={'_blank'}
                        title={trans(`app.flow.more_info`)}
                        iconClassName={'rotate-n45'}
                        textClassName={'ml-2'}
                    />
                </div>
            )}
        </>
    );
}
